import type { SnsError } from '@sumsub/websdk/types/types';
import axios from 'axios';
import { enhanceAxiosErrorMessage } from './enhanceAxiosErrorMessage';
import { enhanceSumsubErrorMessage } from './enhanceSumsubErrorMessage';

import type { OneSdkErrorEvent } from '@/components/session/kyc/idv/OneSdkErrorEvent';
import { getMessage, getOneSdkErrorMessage } from '@/components/session/kyc/errorUtil';

interface Props {
  message: string;
  name?: string;
  cause?: Error;
}

export class ImmersveError extends Error {
  cause?: Error;

  constructor(props: Props) {
    super(props.message);
    this.name = props.name || 'ImmersveError';
    this.cause = props.cause;
  }

  static create({
    name,
    message,
    cause,
  }: {
    name: string;
    message?: string;
    cause?: Error;
  }): ImmersveError {
    return new ImmersveError({ name, message: message || name, cause: cause });
  }

  static fromCause({ name, cause }: { name: string; cause: Error }): ImmersveError {
    const message = axios.isAxiosError(cause) ? enhanceAxiosErrorMessage(cause) : getMessage(cause);
    return ImmersveError.create({ name, message, cause });
  }

  static fromSumsub(error: SnsError): ImmersveError {
    const name = `SumsubWebSdkFailed`;
    const message = enhanceSumsubErrorMessage(error);
    return ImmersveError.create({ name, message });
  }

  static fromOneSdkError(error: OneSdkErrorEvent): ImmersveError {
    const name = `FrankieOneSdkFailed`;
    const message = getOneSdkErrorMessage(error);
    return ImmersveError.create({ name, message });
  }
}
